export default "__VITE_ASSET__J8gurRzv__"